import { useQuery, useQueryClient } from "@tanstack/react-query";
import { researchService } from "../services/research.service";
import type { ResearchChatData } from "../types/research.types";
import { mergeResearchChat, researchChatRefetchInterval } from "./research-chat.utils";

export const useChat = (chatId: string) => {
  const queryClient = useQueryClient();
  return useQuery({
    queryKey: ["chat", chatId],
    queryFn: async () => {
      const incoming = await researchService.getChat(chatId);
      const cached = queryClient.getQueryData<ResearchChatData>(["chat", chatId]);
      return mergeResearchChat(cached, incoming);
    },
    enabled: chatId !== "",
    refetchInterval: (query) => researchChatRefetchInterval(query.state.data),
  });
};
